import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                "VENTAS PRODUCTO\n",
                "POR DIAS\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*", "*"],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        {
          text: "Fecha",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        {
          text: "Cantidad",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
      ],
    ];

    let grouper = [];
    data.forEach((prod) => {
      let exist = pgsHelper.getById(grouper, "id", prod.OriginalId);
      if (!exist) {
        grouper.push({
          id: prod.OriginalId,
          Nombre: prod.Nombre,
          grouperDate: prod.grouperDate,
        });
      }else{
				let fechasVentas = pgsHelper.ArrayObjectToArray(prod.grouperDate)
				fechasVentas.forEach((fecha)=>{
					if(grouper[exist.idx].grouperDate[fecha.id]){
						grouper[exist.idx].grouperDate[fecha.id].Cantidad += fecha.Cantidad
					}else{
						grouper[exist.idx].grouperDate[fecha.id] = {Cantidad:fecha.Cantidad}
					}
				})
			}
    });
		grouper.forEach((prod)=>{
			times.push([{
				text: prod.Nombre,
				border: [true, true, true, true],
				fontSize: 12,
				colSpan: 2,
				fillColor: "#CCE3F4",
			}]);
			let fechasVentas = pgsHelper.ArrayObjectToArray(prod.grouperDate)
			fechasVentas = _.orderBy(
				fechasVentas,
				["id"],
				["asc"]
			);
			fechasVentas.forEach((fecha)=>{
				times.push([
					{
						text: fecha.id,
						border: [true, true, true, true],
						fontSize: 12,
						alignment: "center",
					},
					{
						text: fecha.Cantidad,
						border: [true, true, true, true],
						fontSize: 12,
						alignment: "center",
					},
				],)
			})
		})

    return times;
  }
}
